import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityState } from '../../../entity/entity.reducer';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { getIcsConversationListState } from '../conversation.reducer';
import { IcsConversation } from '../models/conversation';

const createState = (id: IdType) => createSelector(
  getIcsConversationListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createIcsConversationListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.icsConversation
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.icsConversation]], entities) as IcsConversation[]
);

export const createIcsConversationListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createIcsConversationListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createIcsConversationListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createIcsConversationListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createIcsConversationListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
